import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    sit: 'El grupo no presta atención en los primeros 5 minutos',
    sin: 'Repetís la instrucción hasta que funciona',
    con: 'Gancho de apertura activa la atención en 3 minutos'
  }, {
    sit: 'Los estudiantes no recuerdan lo que enseñaste',
    sin: 'Revisás y revisás el mismo tema',
    con: 'Storytelling pedagógico que ancla el contenido en la memoria'
  }, {
    sit: 'La motivación del grupo es baja y constante',
    sin: 'Seguís esperando que mejore sola',
    con: 'Sistema de gamificación sin tecnología que activa el esfuerzo voluntario'
  }, {
    sit: 'Un estudiante difícil desafía tu autoridad',
    sin: 'Reaccionás desde el cansancio',
    con: 'Señales de autoridad magnética que regulan sin confrontación'
  }, {
    sit: 'Querés dejar huella real pero no sabés cómo',
    sin: 'La vocación se siente difusa',
    con: 'Sistema de legado en tres dimensiones con implementación semanal'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-stone-900 mb-10" data-id="element-41">
          🕊️ ¿QUÉ AGREGA DOCENTE MEMORABLE?
        </h2>

        <div className="md:hidden text-center text-sm text-stone-500 mb-4 flex items-center justify-center gap-2" data-id="element-42">
          ← Scroll para ver tabla completa →
        </div>

        <div className="overflow-x-auto pb-4" data-id="element-43">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-44">
            <thead data-id="element-45">
              <tr data-id="element-46">
                <th className="p-4 text-left font-bold text-stone-700 bg-stone-50 border-b-2 border-stone-200 w-1/3" data-id="element-47">
                  Situación en el aula
                </th>
                <th className="p-4 text-left font-bold text-red-700 bg-red-50 border-b-2 border-red-200 w-1/3" data-id="element-48">
                  <div className="flex items-center gap-2" data-id="element-49">
                    <X className="w-5 h-5" data-id="element-50" /> Sin Docente Memorable
                  </div>
                </th>
                <th className="p-4 text-left font-bold text-brand-800 bg-brand-50 border-b-2 border-brand-200 w-1/3" data-id="element-51">
                  <div className="flex items-center gap-2" data-id="element-52">
                    <Check className="w-5 h-5" data-id="element-53" /> Con Docente Memorable
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-54">
              {rows.map((row, i) => <tr key={i} className="border-b border-stone-100 hover:bg-stone-50 transition-colors" data-id="element-55">
                  <td className="p-4 text-stone-800 font-medium" data-id="element-56">{row.sit}</td>
                  <td className="p-4 text-stone-600 bg-red-50/30" data-id="element-57">{row.sin}</td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/50" data-id="element-58">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
export function DocenteMemorableIncludes() {
  const items = ['El ADN del vínculo educativo que más impacta el aprendizaje', 'Sistema de storytelling pedagógico para cualquier materia', '5 tipos de gancho de apertura listos para usar', '4 sistemas de gamificación sin tecnología para el aula del MEP', 'Método socrático aplicado al contexto costarricense', 'Señales de autoridad magnética que construyen respeto real', 'Sistema de legado docente en tres dimensiones', 'Plan de implementación de 7 días con plantillas'];
  return <section className="pb-20 px-4 bg-white" data-id="element-59">
      <div className="max-w-4xl mx-auto bg-brand-50 rounded-3xl p-8 md:p-12 border border-brand-100" data-id="element-60">
        <h3 className="text-2xl font-bold text-brand-900 mb-8 flex items-center gap-3" data-id="element-61">
          <Check className="w-8 h-8 text-brand-600" data-id="element-62" />
          DOCENTE MEMORABLE INCLUYE:
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-63">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3" data-id="element-64">
              <div className="w-2 h-2 rounded-full bg-accent-500 mt-2 flex-shrink-0" data-id="element-65" />
              <span className="text-stone-700 font-medium" data-id="element-66">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}